import { render, staticRenderFns } from "./Carousel3D.vue?vue&type=template&id=12dcad65&scoped=true"
import script from "./Carousel3D.vue?vue&type=script&lang=js"
export * from "./Carousel3D.vue?vue&type=script&lang=js"
import style0 from "./Carousel3D.vue?vue&type=style&index=0&id=12dcad65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dcad65",
  null
  
)

export default component.exports